if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      if (!this.cart) return;

      this.handleErrorMessage();
      this.cart.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/* ---- Robust initialize-from-URL for ?variant=... ---- */
(() => {
  const VARIANT_PARAM = new URLSearchParams(location.search).get('variant');
  if (!VARIANT_PARAM) return;

  const deadline = performance.now() + 6000; // try for up to 6s (covers lazy loaders)

  function getProductJson() {
    // 1) Try inline JSON first (if theme provides it)
    const el = document.querySelector('[id^="ProductJson-"]');
    if (el) {
      try { return JSON.parse(el.textContent); } catch {}
    }
    // 2) Fallback: fetch from Shopify product JSON endpoint
    if (!getProductJson._pending) {
      const handle = location.pathname.replace(/^\/products\//,'').replace(/\/.*$/,'');
      getProductJson._pending = fetch(`/products/${handle}.js`)
        .then(r => r.ok ? r.json() : null)
        .catch(() => null);
    }
    // Return a promise the first time; subsequent calls reuse it
    return getProductJson._pending;
  }

  function tryInit() {
    if (performance.now() > deadline) return;

    const maybeJson = getProductJson();
    if (maybeJson && typeof maybeJson.then === 'function') {
      // async path
      maybeJson.then(json => {
        if (!json) return;
        window.__pf_product = json; // cache for later runs
        doInit(json);
      });
      return;
    }
    if (!maybeJson) return raf(); // neither inline nor fetched yet
    doInit(maybeJson);
  }

  function doInit(product) {
    const variant = product.variants && product.variants.find(v => String(v.id) === String(VARIANT_PARAM));
    if (!variant) return;

    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return raf();

    // Force hidden id and broadcast events (same as before)
    const idInput = form.querySelector('input[name="id"]');
    if (idInput && idInput.value !== String(variant.id)) {
      idInput.value = String(variant.id);
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // … keep the rest of your sync + handlers + gallery code exactly as in the last message …
  }

  function raf() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tryInit, { once: true });
    } else {
      requestAnimationFrame(tryInit);
    }
  }

  raf();

  // If the product section gets re-rendered (Shopify editor/filters), rerun
  document.addEventListener('shopify:section:load', tryInit);
})();
